import React, { FC } from "react";

import { Grid, Skeleton } from "@mui/material";
import { styled, Theme } from "@mui/material/styles";
import { SxProps } from "@mui/system";

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .ag-theme-alpine .ag-cell`]: {
    lineHeight: "unset",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  [`.ag-body-vertical-scroll`]: {
    width: "0 !important",
    minWidth: "0 !important",
  },
  ".ag-body-vertical-scroll-viewport": {
    right: "6px",
  },
  "& ::-webkit-scrollbar": {
    width: "5px",
    // width: 0 /* Remove scrollbar space */,
    // background: "transparent" /* Optional: just make scrollbar invisible */,
  },
  [`ag-body-vertical-scroll-viewport`]: {
    right: "6px",
  },

  [`& .ag-root-wrapper`]: {
    border: "solid 0px !important",
    borderRadius: "15px",
    fontFamily: `${theme.typography.fontFamily}`,
    fontSize: "14px",
    fontWeight: 400,
  },
  [`.ag-full-width-row .ag-cell-wrapper.ag-row-group`]: {
    paddingRight: "10px !important",
  },
  [`& .ag-header-row`]: {
    backgroundColor: theme.palette.primary.main,
    borderTopLeftRadius: "15px",
    borderTopRightRadius: "15px",
  },
  [`& .ag-header-cell-text`]: {
    color: "white",
    fontWeight: "600",
  },
  [`& .ag-theme-alpine .ag-cell-inline-editing`]: {
    height: `50px`,
  },
  [`& .ag-header-row-column-group`]: {
    backgroundColor: theme.palette.primary.main,
  },
  [`& .ag-header-row:not(:first-of-type) .ag-header-cell`]: {
    borderTop: "solid 0px !important",
  },
  [`& .ag-header-group-text`]: {
    fontWeight: 500,
  },
  [`& .ag-header-group-cell-label`]: {
    justifyContent: "center",
    color: "white",
  },
  [`& .ag-group-value`]: {
    width: "100%",
  },
  [`& .ag-header`]: {
    borderBottom: "solid 0px !important",
  },
  [`& .ag-popup-child:not(.ag-tooltip-custom)`]: {
    backgroundColor: "white",
    borderRadius: "10px",
    fontFamily: `${theme.typography.fontFamily}`,
    fontSize: "14px",
    fontWeight: 400,
  },
  [`& .ag-header-cell-label`]: {
    justifyContent: "center",
    fontWeight: 400,
    marginRight: "-16px",
  },
  // for the exp table alignment
  [`& .header-custom`]: {
    "& .ag-header-cell-label": {
      justifyContent: "left !important",
    },
  },
  [`& .header-custom2`]: {
    "& .ag-header-cell-label": {
      marginRight: "0px !important",
    },
  },
}));

interface IgTableWrapperProps {
  children: any;
  isLoading?: boolean;
  height?: string;
  sx?: SxProps<Theme>;
}

/**
 * @see Grid
 * @see Skeleton
 */
export const IgTableWrapper: FC<IgTableWrapperProps> = ({
  children,
  height,
  isLoading,
  sx,
}) => {
  return (
    <StyledGrid direction={"column"} container sx={sx}>
      {isLoading ? (
        <Skeleton variant={"rectangular"} height={height || "500px"} />
      ) : (
        <div className="ag-theme-alpine" style={{ height: height || "500px" }}>
          {children}
        </div>
      )}
    </StyledGrid>
  );
};
